import { Typography } from "@material-ui/core";
import {Link} from "react-router-dom";
// import {useRef} from "react";
// import useOnScreen from "../../common/componentVisibleHook";
import '../styles.scss';

const ViewMenuButton = () => {

  // const ref = useRef();

  // const isVisible = useOnScreen(ref, 1);

  return (
      <Link to={'/menu'} className='button-wrapper'>
        <div className='button-text'>
          <Typography variant="h3">View Menu</Typography>
        </div>
        <svg height='160' width='250'>
          <rect className='shape' height='160' width='250' />
        </svg>
      </Link>
  );
};

export default ViewMenuButton;
